import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend);

const QuizSummaryChart = ({ quizSummary }) => {
  const data = {
    labels: ["Correct", "Wrong"],
    datasets: [
      {
        label: "Quiz Performance",
        data: [quizSummary.totalCorrect, quizSummary.totalWrong],
        backgroundColor: ["#4CAF50", "#F44336"], // green for correct, red for wrong
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || "";
            const value = context.parsed;
            const total = quizSummary.totalQuestions;
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div className="" style={{ width: "300px", margin: "auto" }}>
      <Doughnut data={data} options={options} />
      <p className="position-absolute" style={{top: 50, left: 10}}>
        Total Questions: {quizSummary.totalQuestions}
      </p>
    </div>
  );
};

export default QuizSummaryChart;
